import { create } from "zustand";

type AlertData = {
    header : string
    body : string
    button : string
}

type AlertStore = {
    alert : AlertData | null
    showAlert : (data : AlertData) => void
    closeAlert : () => void
}

export const useAlertStore = create<AlertStore>((set) => ({
    alert : null,
    showAlert : (data) => set({alert : data}),
    closeAlert : () => set({alert : null})
}))